<template>
  <div class="club-list-container">
    <!-- 页面主体 (默认显示) -->
    <div class="container">
      <!-- 顶部区域：标题 -->
      <div class="header">
        <div class="title">我的球杆列表</div>
      </div>

      <!-- 球杆列表 -->
      <div v-if="clubList.length > 0" class="card-list">
        <el-row :gutter="20">
          <!-- 循环渲染每一个球杆卡片 -->
          <el-col
              v-for="club in clubList"
              :key="club.id"
              :span="8"
              :xs="24"
              :sm="12"
              class="card-container"
          >
            <el-card shadow="hover" class="club-card">
              <!-- 卡片主体内容 -->
              <div class="card-body">
                <div class="info-item">
                  <span class="label">序列号:</span>
                  <span class="value value_xlh">{{ club.value }}</span>
                  <el-button  class="label_button" @click="handBenefitsClick(club)">查看权益</el-button>
                </div>
                <div class="info-item">
                  <span class="label">品牌:</span>
                  <span class="value">{{ club.brand }}</span>
                </div>
                <div class="info-item">
                  <span class="label">系列:</span>
                  <span class="value">{{ club.model }}</span>
                </div>
                <!-- 只有提交过权益申请才显示状态-->
                <div class="info-item" v-if="club.businessId && (club.state == '1' || club.state == '2')">
                  <span class="label">状态:</span>
                  <span v-if="club.state == '1'" class="value value_xlh">{{ club.type=='1'?'置换':'翻新' }}审核中</span>
                  <span v-if="club.state == '2'" class="value value_xlh">{{ club.type=='1'?'置换':'翻新' }}中</span>
                  <el-button v-if="club.state == '1' || club.state == '2'" class="label_button" @click="handBenefitsCancelClickConfirm(club.businessId,club.type)">取消{{ club.type=='1'?'置换':'翻新'}}</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

      </div>

      <!-- 空数据提示 -->
      <div v-else class="empty-state">
        <el-empty description="暂无球杆信息"></el-empty>
      </div>

      <div class="btn-group-back">
        <el-button type="default" @click="goHome">返回首页</el-button>
      </div>

      <!-- 页脚 -->
      <el-footer class="footer">
        <p>JING-DIAN BILLIARD CLUB AFTER SALES</p>
      </el-footer>
    </div>
    <!-- 调用提示语弹框组件 -->
    <MessageDialog
        v-if="showDialog"
        :title="dialogTitle"
        :content="messageContent"
        :confirmText="confirmText"
        :showCancel="showCancel"
        @confirm="handleDialogConfirm"
        @cancel="handleCancel"
        @close="showDialog = false"
        closeOnMask
    />
  </div>
</template>

<script>
import {benefitsByUser, cancelBenefits} from "@/api/sales";
import MessageDialog from "@/views/business/utils/messageDialog.vue";

export default {
  name: "ClubList",
  components: {MessageDialog},
  data() {
    return {
      // 球杆列表数据
      clubList: [],
      // 提示弹框组件
      showDialog: false,
      dialogTitle: '提示',
      messageContent: '',
      confirmText: '',
      dialogFlag: '',
      showCancel: false,

      businessId: '',
    };
  },
  created() {
    this.fetchClubList();
  },
  methods: {
    //询问框确认事件
    handleDialogConfirm(){
      this.showDialog = false;
      this.handBenefitsCancelClick(this.businessId);
    },
    //取消事件
    handleCancel(){
      this.businessId = '';
      this.showDialog = false;
    },
    // 返回首页
    goHome() {
      // 实际项目可替换为Vue Router跳转：this.$router.push('/')
      this.$router.replace('/sales_home');
    },
    //查看权益
    handBenefitsClick(club) {
      this.$router.push({
        path: '/benefits',
        query: {
          number: club.value+"_"+club.brandCode+"_"+club.modelCode,
          state: club.state
        }
      })
    },
    //取消权益询问事件
    handBenefitsCancelClickConfirm(businessId,type){

      this.businessId = businessId;
      //提示信息提示弹框组件是否显示
      this.showDialog = true;
      //显示取消按钮
      this.showCancel = true;
      //确认按钮文案
      this.confirmText = "确定";
      //提示信息内容
      const typeTitle = type=='1'?'置换':'翻新'
      this.messageContent = '确定要取消'+typeTitle+'吗？';
    },
    //取消权益
    async handBenefitsCancelClick(businessId) {
      try {
        const res = await cancelBenefits(businessId);
        if(res.code==200){
          this.businessId = '';
          //提示信息提示弹框组件是否显示
          this.showDialog = true;
          //显示取消按钮
          this.showCancel = false;
          //确认按钮文案
          this.confirmText = "我知道了";
          //提示信息内容
          this.messageContent = '取消成功!';
          setTimeout(() => {
            this.fetchClubList();
          }, 2000);
        }
      } catch (error) {
        console.error("获取球杆列表失败:", error);
      }
    },
    async fetchClubList() {
      try {
        const response = await benefitsByUser();
        this.clubList = response.data;
      } catch (error) {
        console.error("获取球杆列表失败:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 页面整体容器
.club-list-container {
  width: 100%;
  background-color: #f9f9f9;
  min-height: 100vh;

  .container {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    // 顶部区域
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      background: #f6c27a;
    }

    // 顶部标题
    .title {
      text-align: center;
      flex-grow: 1;
      line-height: 60px;
      font-size: 16px;
      color: #161616;
      letter-spacing: 1px;
      font-weight: bold;
      margin: 0;
    }

    // 卡片列表容器
    .card-list {
      width: 100%;
      margin: 0;
      padding: 20px;
      max-height: 70vh;
      height: 70vh;
    }

    // 每个卡片的容器
    .card-container {
      margin-bottom: 20px;
    }

    // 卡片样式
    .club-card {
      height: 100%;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      cursor: pointer;
    }

    // 卡片主体
    .card-body {
      flex-grow: 1;
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    // 信息项样式
    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        font-weight: bold;
        color: #555;
        width: 180px; // <-- 使用固定宽度
        text-align-last: justify; // <-- 核心：实现两端对齐
      }

      .label_button {
        background: #f6c27a;
        color: #555;
      }

      .value {
        color: #333;
        word-break: break-all;
        padding-left: 20px; // 增加一点与label的间距
      }
    }

    // 空状态提示
    .empty-state {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 400px;
      background-color: #fff;
      border-radius: 8px;
      margin: 20px;
    }
    .btn-group-back {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin: 20px 0;
    }

    // 页脚
    .footer {
      height: 50px;
      background: #2c2c2c;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      box-sizing: border-box;

      p {
        color: #ea9538;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
        margin: 0;
      }
    }
  }

  // ===================== 移动端适配（<768px） =====================
  @media screen and (max-width: 767px) {
    .container {
      .header {
        padding: 0 10px;
      }

      .title {
        font-size: 16px;
        line-height: 60px;
      }
      .card-list {
        padding: 10px;
      }
      .club-card {
        border-radius: 10px;
      }
      .info-item {
        font-size: 14px;
        .label {
          width: 80px;
          font-weight: 500;
        }
        .value {
          padding-left: 10px;
        }
        .value_xlh{
          width: 160px;
        }
        .label_button {
          font-size: 14px;
          width: 90px;
          line-height: 20px;
        }
      }

      .empty-state {
        margin: 10px;
        height: 300px;
      }
      .el-button--default{
        font-size: 20px;
        color: #0f0f0f;
        background: #dcdcdc;
        border: none;
        width: 80%;
        border-radius: 3px;
      }
      .btn-group-back {
        display: flex;
        justify-content: center;
        gap: 15px;
        height: 40px;
        line-height: 40px;
        margin: 20px 0 20px 0;
      }
      .footer {
        height: 50px;
        margin-top: 15px;
        p {
          font-size: 9px;
          padding: 0 10px;
          text-align: center;
        }
      }
    }
  }

  // ===================== 平板和PC端适配（≥768px） =====================
  @media screen and (min-width: 768px) {
    .container {
      .card-list-wrapper {
        max-width: 700px; // 平板和PC端可以适当放宽
      }
      .info-item {
        font-size: 16px;
        .label {
          width: 120px;
        }
        .value {
          padding-left: 20px;
        }
      }
      .empty-state {
        max-width: 700px;
        margin: 20px auto;
      }
      .footer {
        height: 55px;
        margin-top: 25px;
        p {
          font-size: 11px;
        }
      }
    }
  }
}
</style>